import { render, staticRenderFns } from "./DayEquipParaList.vue?vue&type=template&id=355463f4&"
import script from "./DayEquipParaList.vue?vue&type=script&lang=js&"
export * from "./DayEquipParaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports